import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Unstable_Grid2';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

function CardEnableCPTexting({
  classes,
  loading = false,
  isConfirmed = false,
  onConfirmationChange = () => { },
}) {
  const {
    cpTextingGuideUrl,
  } = useSelector((state) => state.account) || {};

  const handleOpenGuide = () => {
    const guideUrl = cpTextingGuideUrl || 'https://help.connectionpointsoftware.com/getting-ready-for-cp-texting';
    window.open(guideUrl, '_blank');
  };

  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    console.log('Checkbox changed:', checked); // Add this debug log
    onConfirmationChange(checked);
  };

  return (
    <div className={classes.cardBox}>
      <Grid container>
        <Grid xs={12}>
          <div className={classes.contentBox}>
            <div className={classes.iconBox}>
              🚀
            </div>
            <div className={classes.titleBox}>
              Your TCR Registration is Approved!
            </div>
            <div className={classes.subtitleBox}>
              You can now activate Connection Point texting
            </div>
            <div className={classes.descriptionBox}>
              Great news! Your TCR (The Campaign Registry) registration has been approved by the carriers.
              This means you can now enable Connection Point's powerful texting features and start using
              all of CP's automation tools for your business.
            </div>

            <div className={classes.featuresList}>
              <strong>Once you activate CP texting, you'll be able to:</strong>
              <ul>
                <li>Send and receive text messages directly in Connection Point</li>
                <li>View all of your scheduled messages in CP</li>
                <li>Send team communications and announcements</li>
                <li>Set up smart automation campaigns</li>
              </ul>
            </div>

            <div className={classes.warningBox}>
              <strong>Important:</strong>
              {' '}
              Once you activate Connection Point texting, your Project Broadcast integration will be switched off.
              <br />
              Make sure you are ready to fully transition to CP's built-in texting.
            </div>

            <div className={classes.checkboxContainer}>
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={isConfirmed}
                    onChange={handleCheckboxChange}
                    color="primary"
                    disabled={loading}
                  />
                )}
                label={(
                  <span>
                    I confirm that I am ready to activate Connection Point texting and have reviewed the
                    {' '}
                    <button
                      type="button"
                      className={classes.linkButton}
                      onClick={handleOpenGuide}
                      disabled={loading}
                    >
                      Getting Ready for CP Texting Guide
                    </button>
                  </span>
                )}
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

CardEnableCPTexting.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  isConfirmed: PropTypes.bool,
  onConfirmationChange: PropTypes.func,
};

export default CardEnableCPTexting;
